import InternalStudentLevelsDao from '../dao/internal-student-levels.dao';
import type { Environment } from '../interfaces/environment';

export abstract class InternalStudentLevelsService {
  static changeStudentLevel(
    env: Environment,
    personId?: number,
    contactId?: string,
    levelNum?: string
  ) {
    return !personId || !levelNum || !contactId
      ? Promise.reject(new Error('Invalid personId or levelNum'))
      : InternalStudentLevelsDao.changeStudentLevel(
          env,
          personId,
          contactId,
          levelNum
        );
  }
}
